import { c as _c } from "react/compiler-runtime";
import React from "react";
import styles from "./Toast.module.css";
interface ToastProps {
  message: string;
  isVisible: boolean;
}
export default React.memo(function Toast(t0) {
  const $ = _c(3);
  const {
    message,
    isVisible
  } = t0;
  const t1 = `${styles.toast} ${isVisible ? styles.visible : ""}`;
  let t2;
  if ($[0] !== message || $[1] !== t1) {
    t2 = <div className={t1} role="status">{message}</div>;
    $[0] = message;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
});